import axios from 'axios'
import AlertModule from 'vux/src/plugins/alert/module'

import Confirm from 'vux/src/components/confirm/index.vue'

import store from '../store'
import { getToken } from '@/utils/auth'
import {getCurrentUrl} from "./auth";


const service = axios.create({
baseURL: process.env.BASE_API, // api 的 base_url
timeout: 120000 
})


service.interceptors.request.use(
config => {
if (store.getters.token) {
config.headers['Admin-Sign-Token'] = getToken() 
config.headers['Current-Url'] = 'teacher'
}

return config
},
error => {
Promise.reject(error)
}
)


service.interceptors.response.use(
response => {
/**
* code为非20000是抛错 可结合自己业务进行修改
*/
var res = response.data
var typeData = typeof res

if (typeData === 'string') {
res = eval('(' + res + ')')
}

if (res.code !== 20000) {
if(res.message != null && res.message != ""){
AlertModule.show({
title:'错误提示',
content: res.message
})
}else{
AlertModule.show({
title:'错误提示',
content: res.data
})
}



if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
AlertModule.show({
title:'错误提示',
content: res.message
})
}
return Promise.reject('error')
} else if (!res.success) {
console.log(res)

AlertModule.show({
title: '错误提示',
content: res.message
})
return Promise.reject('error')
} else {
return res
}
},
error => {
AlertModule.show({
title: '错误提示',
content: error.message,
})
return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js